import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { loadOneStatement } from "./ActionStatements";
import { removeCommas } from "../../components/general/general-component/abstruct-component/FunctionRemoveCommas";
import { useSelectorCustom } from "../../components/general/general-component/abstruct-component/useSelectorCustom";
const END_POINT = process.env.REACT_APP_BASE_URL_ACCOUNTING;



const add = (type) => {
    return ({
        type: type
    })
}
const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}
const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}

export const postExpenses = (state, setLoad, viewExpenses) => {
    return function (dispatch) {
        setLoad(true)
        let user_id = localStorage.getItem('XX')
        let token = localStorage.getItem("tokenA");
        const body = {
            descriptions: state.description,
            invoice_number: state.invoice_number,
            notes: state.notes,
            date: state.date,
            expense_statement_id: state.statement_id,
            amount: parseInt(removeCommas(state.amount)),
            revolving: state.revolving ? 1 : 0,
            remaining_amount: parseInt(removeCommas(state.remaining_amount)),
        }
        if (state.invoice_image !== '') {
            body.invoice_image = state.invoice_image;
        }
        if (state.delivery_receipt_image !== '') {
            body.delivery_receipt_image = state.delivery_receipt_image;
        }
        console.log(body)
        axios.post(`${END_POINT}/api/expenses`, body, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_EXPENSE));
                if (viewExpenses === 'yes') {
                    dispatch(loadOneStatement(state.statement_id))
                }
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}

export const loadExpenses = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/expenses`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_EXPENSES));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const getPageListExpenses = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        let user_id = localStorage.getItem('XX')
        axios.get(`${END_POINT}/api/expenses/create`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res?.data?.data, types.PAGE_LIST_EXPENSE));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const loadOneExpense = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/expenses/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_ONE_EXPENSE));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const emptyOneExpense = () => {
    return function (dispatch) {
        let emptyy = {}
        dispatch(emptyGeneral(emptyy, types.EMPTY_ONE_EXPENSE))
    }
}

export const deleteExpense = (id, setloadDel, setIsDeleted, setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/expenses/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_EXPENSE));
                notifysuccess(res.data.message)
                //dispatch(loadUsers());
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putExpense = (id, name, email, password, role, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const formValues = {
            name: name,
            email: email,
            role: role
        };
        if (password !== '') {
            formValues.password = password;
        }
        axios.put(`${END_POINT}/api/expenses/${id}`, formValues, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_EXPENSE));
                dispatch(loadExpenses());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}


export const filterExpenses = (search_value, date, expense_statement_id, revolving, account_id, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        let user_id = localStorage.getItem('XX')
        setLoad(true);
        const queryParams = [];
        if (search_value !== '') queryParams.push(`filters[search_value]=${search_value}`);
        if (date !== '') queryParams.push(`filters[date]=${date}`);
        if (expense_statement_id !== '') queryParams.push(`filters[expense_statement_id]=${expense_statement_id}`);
        if (revolving !== '') queryParams.push(`filters[revolving]=${revolving ? 1 : 0}`);
        if (account_id !== '') queryParams.push(`filters[account_id]=${account_id}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/expenses?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            setLoad(false);
            dispatch(get(res.data.data?.expenses, types.GET_EXPENSES));
            dispatch(get(res.data.data?.accountDetails, types.GET_EXPENSES1));
        }).catch((err) => {
            ;
            setLoad(false);
        });
    };
};

export const exportExpenses = (search_value, date, expense_statement_id, revolving, account_id, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        let user_id = localStorage.getItem('XX');
        setLoad(true);
        const queryParams = [];
        if (search_value !== '') queryParams.push(`filters[search_value]=${search_value}`);
        if (date !== '') queryParams.push(`filters[date]=${date}`);
        if (expense_statement_id !== '') queryParams.push(`filters[expense_statement_id]=${expense_statement_id}`);
        if (revolving !== '') queryParams.push(`filters[revolving]=${revolving ? 1 : 0}`);
        if (account_id !== '') queryParams.push(`filters[account_id]=${account_id}`);
        queryParams.push(`type=Expense`);
        queryParams.push(`is_all_selected=true`);
        const finalQuery = queryParams.join('&');

        const apiUrl = `${END_POINT}/api/print?${finalQuery}`;

        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            setLoad(false);
            // Create a temporary link element for downloading the file
            const link = document.createElement('a');
            link.href = res.data?.file_url;
            link.target = '_blank'; // Ensure it opens in a new tab if needed
            link.download = 'expenses.pdf'; // Specify the filename
            
            // Append the link to the DOM, trigger a click, and then remove the link
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }).catch((err) => {
            setLoad(false);
            console.error("Error downloading the file: ", err);
        });
    };
};

